<div class="min-h-screen bg-gray-50">
  <!-- Header -->
  <div class="bg-gradient-to-r from-[#2c5f8d] to-[#4A90E2] text-white py-6">
    <div class="container max-w-4xl mx-auto px-4 sm:px-6">
      <div class="flex items-center justify-between">
        <div>
          <h1 class="text-2xl sm:text-3xl font-bold">{{ isEditMode ? 'Editar Meus Dados' : 'Cadastro do Candidato' }}</h1>
          <p class="text-white/90 text-sm sm:text-base mt-1">
            {{ isEditMode 
              ? 'Atualize suas informações pessoais'
              : 'Candidato, utilize o formulário abaixo para cadastrar suas informações pessoais' }}
          </p>
        </div>
        <a
          routerLink="/login"
          class="text-white/90 hover:text-white text-sm font-medium hidden sm:flex items-center gap-2"
        >
          Já tem conta? Entrar
          <svg
            class="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M14 5l7 7m0 0l-7 7m7-7H3"
            />
          </svg>
        </a>
      </div>
    </div>
  </div>

  <!-- Success Message -->
  <div
    *ngIf="successMessage"
    class="container max-w-2xl mx-auto px-4 sm:px-6 py-8 sm:py-12"
  >
    <div
      class="bg-white rounded-lg p-6 sm:p-8 shadow-sm border border-gray-200"
    >
      <div class="text-center">
        <div
          class="w-16 h-16 sm:w-20 sm:h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4"
        >
          <svg
            class="w-10 h-10 sm:w-12 sm:h-12 text-green-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
        <h2 class="text-xl sm:text-2xl font-bold text-gray-900 mb-2">
          Cadastro Realizado com Sucesso!
        </h2>
        <p class="text-sm sm:text-base text-gray-600 mb-4">
          Sua conta foi criada. Redirecionando para o login...
        </p>
        <div
          class="animate-spin rounded-full h-8 w-8 border-b-2 border-[#4A90E2] mx-auto"
        ></div>
      </div>
    </div>
  </div>

  <!-- Form -->
  <div
    *ngIf="!successMessage"
    class="container max-w-4xl mx-auto px-4 sm:px-6 py-6 sm:py-8"
  >
    <!-- Container de Suporte (apenas em modo edição) -->
    <div *ngIf="isEditMode" class="mb-6 bg-blue-50 border border-blue-200 rounded-lg p-4 sm:p-6">
      <div class="flex items-start gap-3">
        <svg class="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        <div>
          <h3 class="text-sm font-semibold text-blue-900 mb-2">
            Para alterar Nome Completo, CPF e Data de Nascimento, por favor entre em contato com o suporte
          </h3>
          <div class="space-y-1 text-sm text-blue-800">
            <p><strong>Suporte</strong></p>
            <p>concurso&#64;recrutamentobrasil.com.br</p>
            <p>+55 (11) 3164-0969</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Progress Steps -->
    <div class="mb-6 sm:mb-8">
      <app-progress-steps
        [steps]="progressSteps"
        [currentStep]="currentStep"
        [canNavigate]="true"
        [hasError]="hasError"
        [errorStep]="errorStep"
        [warningSteps]="warningSteps"
        [disabledSteps]="disabledSteps"
        [submitted]="submitted"
        (stepChange)="setStep($event)"
        (stepClick)="setStep($event)"
      ></app-progress-steps>
    </div>

    <div
      class="bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-6 md:p-8"
    >
      <form (ngSubmit)="onSubmit()" #registerForm="ngForm">
        <!-- Step 1: Identificação -->
        <div *ngIf="currentStep === 1">
          <h2 class="text-lg sm:text-xl font-bold text-gray-900 mb-1">
            Identificação
          </h2>
          <p class="text-gray-600 mb-4 sm:mb-6 text-sm">
            Preencha seus dados de identificação
          </p>

          <div class="space-y-3 sm:space-y-4">
            <!-- Nome Completo -->
            <app-input
              label="Nome Completo do Candidato (Conforme Identidade)"
              [(ngModel)]="formData.nomeCompleto"
              name="nomeCompleto"
              #nomeCompleto="ngModel"
              required
              placeholder="Digite seu nome completo"
              [readonly]="isEditMode"
              [error]="
                submitted && nomeCompleto.invalid
                  ? 'Nome completo é obrigatório'
                  : ''
              "
            ></app-input>

            <!-- Sexo -->
            <div>
              <app-select
                label="Sexo"
                [(ngModel)]="formData.sexo"
                name="sexo"
                #sexo="ngModel"
                [options]="sexoOptions"
                required
                [error]="submitted && sexo.invalid ? 'Sexo é obrigatório' : ''"
              ></app-select>
            </div>

            <!-- Nome Social -->
            <!-- Adicionar depois -->
            <!-- <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <div class="mb-3">
                <p class="text-sm text-gray-700 mb-2">
                  De acordo com o <strong>Decreto 8.727/2016</strong>, o usuário
                  <strong>Travesti</strong> ou
                  <strong>Transexual</strong> poderá optar pela exibição do
                  <strong>Nome Social</strong> nas buscas públicas.
                  <a
                    href="https://www.mds.gov.br/webarquivos/publicacao/assistencia_social/Folders/cartilha_nome_social.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="inline-flex items-center text-sm text-blue-600 hover:text-blue-800 font-medium"
                  >
                    Saiba mais
                  </a>
                </p>
                <p class="text-sm text-gray-900 font-medium mb-3">
                  Declaro que sou candidato(a) <strong>Travesti</strong> ou
                  <strong>Transexual</strong> e desejo utilizar o Nome Social:
                </p>
                <div class="flex gap-6 mb-1">
                  <label class="flex items-center gap-2 cursor-pointer">
                    <input
                      type="radio"
                      name="usarNomeSocial"
                      value="sim"
                      [(ngModel)]="formData.usarNomeSocial"
                      class="w-4 h-4 accent-blue-500"
                    />
                    <span class="text-sm font-medium text-gray-900">SIM</span>
                  </label>
                  <label class="flex items-center gap-2 cursor-pointer">
                    <input
                      type="radio"
                      name="usarNomeSocial"
                      value="nao"
                      [(ngModel)]="formData.usarNomeSocial"
                      class="w-4 h-4 accent-blue-500"
                    />
                    <span class="text-sm font-medium text-gray-900">NÃO</span>
                  </label>
                </div>
              </div>

              <div *ngIf="formData.usarNomeSocial === 'sim'">
                <app-input
                  label="Nome Social"
                  [(ngModel)]="formData.nomeSocial"
                  name="nomeSocial"
                  #nomeSocial="ngModel"
                  [required]="formData.usarNomeSocial === 'sim'"
                  placeholder="Digite o nome social"
                  hint="Ao selecionar SIM, a busca pública será realizada somente a partir dos componentes (prenome e sobrenome) do nome social abaixo."
                ></app-input>
              </div>
            </div> -->

            <!-- Data de Nascimento -->
            <div>
              <label class="block text-sm font-medium text-gray-900 mb-1"
                >Data de Nascimento *</label
              >
              <div class="grid grid-cols-3 gap-2">
                <app-select
                  placeholder="Dia"
                  [(ngModel)]="formData.diaNascimento"
                  name="diaNascimento"
                  #diaNascimento="ngModel"
                  [required]="!isEditMode"
                  [disabled]="isEditMode"
                  [error]="
                    submitted && diaNascimento.invalid
                      ? 'Dia é obrigatório'
                      : ''
                  "
                  [options]="dias"
                  [class.border-red-500]="submitted && diaNascimento.invalid"
                ></app-select>
                <app-select
                  placeholder="Mês"
                  [(ngModel)]="formData.mesNascimento"
                  name="mesNascimento"
                  #mesNascimento="ngModel"
                  [required]="!isEditMode"
                  [disabled]="isEditMode"
                  [error]="
                    submitted && mesNascimento.invalid
                      ? 'Mês é obrigatório'
                      : ''
                  "
                  [options]="meses"
                  [class.border-red-500]="submitted && mesNascimento.invalid"
                ></app-select>
                <app-select
                  placeholder="Ano"
                  [(ngModel)]="formData.anoNascimento"
                  name="anoNascimento"
                  #anoNascimento="ngModel"
                  [required]="!isEditMode"
                  [disabled]="isEditMode"
                  [error]="
                    submitted && anoNascimento.invalid
                      ? 'Ano é obrigatório'
                      : ''
                  "
                  [options]="anos"
                  [class.border-red-500]="submitted && anoNascimento.invalid"
                ></app-select>
              </div>
            </div>

            <!-- CPF e RG -->
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <app-input
                label="CPF"
                [(ngModel)]="formData.cpf"
                name="cpf"
                #cpf="ngModel"
                [required]="!isEditMode"
                [readonly]="isEditMode"
                mask="cpf"
                [error]="getCpfError(cpf)"
              ></app-input>

              <app-input
                label="RG ou NOVO Registro Geral"
                [(ngModel)]="formData.rg"
                name="rg"
                #rg="ngModel"
                required
                placeholder="Digite o RG"
                [error]="submitted && rg.invalid ? 'RG é obrigatório' : ''"
              ></app-input>
            </div>

            <!-- Nome do Pai e Mãe -->
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <app-input
                  label="Nome do Pai"
                  [(ngModel)]="formData.nomePai"
                  name="nomePai"
                  placeholder="Nome completo do pai"
                ></app-input>
                <app-input
                  label="Profissão do Pai"
                  [(ngModel)]="formData.profissaoPai"
                  name="profissaoPai"
                  placeholder="Profissão do pai"
                  class="mt-3"
                ></app-input>
              </div>

              <app-input
                label="Nome da Mãe"
                [(ngModel)]="formData.nomeMae"
                name="nomeMae"
                #nomeMae="ngModel"
                required
                placeholder="Nome completo da mãe"
                [error]="
                  submitted && nomeMae.invalid
                    ? 'Nome da mãe é obrigatório'
                    : ''
                "
              ></app-input>
            </div>

            <!-- Nacionalidade, Estado Civil, Escolaridade -->
            <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <app-select
                label="Nacionalidade"
                [(ngModel)]="formData.nacionalidade"
                name="nacionalidade"
                #nacionalidade="ngModel"
                [options]="nacionalidadeOptions"
                required
                [error]="
                  submitted && nacionalidade.invalid
                    ? 'Nacionalidade é obrigatória'
                    : ''
                "
              ></app-select>

              <app-select
                label="Estado Civil"
                [(ngModel)]="formData.estadoCivil"
                name="estadoCivil"
                #estadoCivil="ngModel"
                [options]="estadoCivilOptions"
                required
                [error]="
                  submitted && estadoCivil.invalid
                    ? 'Estado civil é obrigatório'
                    : ''
                "
              ></app-select>

              <app-select
                label="Nível de Escolaridade"
                [(ngModel)]="formData.escolaridade"
                name="escolaridade"
                #escolaridade="ngModel"
                [options]="escolaridadeOptions"
                required
                [error]="
                  submitted && escolaridade.invalid
                    ? 'Escolaridade é obrigatória'
                    : ''
                "
              ></app-select>
            </div>

            <!-- Número de Dependentes e Telefone -->
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label class="block text-sm font-medium text-gray-900 mb-1"
                  >Número de Dependentes *</label
                >
                <input
                  type="number"
                  [(ngModel)]="formData.numeroDependentes"
                  name="numeroDependentes"
                  required
                  min="0"
                  class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4A90E2] focus:border-transparent"
                  placeholder="0"
                />
              </div>

              <app-input
                label="Telefone Pessoal"
                type="text"
                [(ngModel)]="formData.telefone"
                name="telefone"
                #telefone="ngModel"
                required
                mask="phone"
                [error]="
                  submitted && telefone.invalid ? 'Telefone é obrigatório' : ''
                "
              ></app-input>
            </div>

            <!-- Outro Telefone -->
            <app-input
              label="Outro Telefone (Opcional)"
              [(ngModel)]="formData.outroTelefone"
              name="outroTelefone"
              mask="phone"
              placeholder="(00) 00000-0000"
              type="text"
            ></app-input>

            <!-- Alerta de erro -->
            <div
              *ngIf="submitted && !validateCurrentStep()"
              class="bg-red-50 border border-red-200 rounded-lg p-4"
            >
              <div class="flex gap-3">
                <svg
                  class="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                    clip-rule="evenodd"
                  />
                </svg>
                <div>
                  <h3 class="text-sm font-medium text-red-800 mb-1">
                    Campos obrigatórios não preenchidos
                  </h3>
                  <p class="text-sm text-red-700">
                    Por favor, preencha todos os campos obrigatórios marcados
                    com * para continuar.
                  </p>
                </div>
              </div>
            </div>

            <button
              type="button"
              (click)="nextStep()"
              class="w-full bg-[#4A90E2] text-white py-3 px-6 rounded-lg font-semibold hover:bg-[#3a7fc2] transition-colors"
            >
              Continuar
            </button>
          </div>
        </div>

        <!-- Step 2: Endereço -->
        <div *ngIf="currentStep === 2">
          <h2 class="text-lg sm:text-xl font-bold text-gray-900 mb-1">
            Endereço
          </h2>
          <p class="text-gray-600 mb-4 sm:mb-6 text-sm">
            Preencha seu endereço residencial
          </p>

          <div class="space-y-4">
            <!-- CEP, Estado, Cidade -->
            <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div>
                <app-input
                  label="CEP"
                  [(ngModel)]="formData.cep"
                  name="cep"
                  #cep="ngModel"
                  required
                  mask="cep"
                  [error]="submitted && cep.invalid ? 'CEP é obrigatório' : ''"
                  [hint]="cepLoading ? 'Buscando CEP...' : cepError || ''"
                  (blur)="buscarCep()"
                ></app-input>
              </div>

              <app-select
                label="Estado"
                [(ngModel)]="formData.estadoId"
                name="estadoId"
                #estadoId="ngModel"
                [options]="estadoOptions"
                (ngModelChange)="onEstadoChange()"
                required
                [error]="
                  submitted && estadoId.invalid ? 'Estado é obrigatório' : ''
                "
              ></app-select>

              <app-select
                label="Cidade"
                [(ngModel)]="formData.cidadeId"
                name="cidadeId"
                #cidadeId="ngModel"
                [options]="cidadeOptions"
                required
                [error]="
                  submitted && cidadeId.invalid ? 'Cidade é obrigatória' : ''
                "
              ></app-select>
            </div>

            <!-- Endereço -->
            <app-input
              label="Endereço"
              [(ngModel)]="formData.endereco"
              name="endereco"
              #endereco="ngModel"
              required
              placeholder="Rua, Avenida, etc."
              [error]="
                submitted && endereco.invalid ? 'Endereço é obrigatório' : ''
              "
            ></app-input>

            <!-- Bairro, Número, Complemento -->
            <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <app-input
                label="Bairro"
                [(ngModel)]="formData.bairro"
                name="bairro"
                #bairro="ngModel"
                required
                placeholder="Nome do bairro"
                [error]="
                  submitted && bairro.invalid ? 'Bairro é obrigatório' : ''
                "
              ></app-input>

              <app-input
                label="Número"
                [(ngModel)]="formData.numero"
                name="numero"
                #numero="ngModel"
                required
                placeholder="Nº"
                [error]="
                  submitted && numero.invalid ? 'Número é obrigatório' : ''
                "
              ></app-input>

              <app-input
                label="Complemento"
                [(ngModel)]="formData.complemento"
                name="complemento"
                placeholder="Apto, Bloco, etc."
              ></app-input>
            </div>

            <!-- Alerta de erro Passo 2 -->
            <div
              *ngIf="submitted && !validateCurrentStep()"
              class="bg-red-50 border border-red-200 rounded-lg p-4"
            >
              <div class="flex gap-3">
                <svg
                  class="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                    clip-rule="evenodd"
                  />
                </svg>
                <div>
                  <h3 class="text-sm font-medium text-red-800 mb-1">
                    Campos obrigatórios não preenchidos
                  </h3>
                  <p class="text-sm text-red-700">
                    Por favor, preencha todos os campos obrigatórios marcados
                    com * para continuar.
                  </p>
                </div>
              </div>
            </div>

            <!-- Botões -->
            <div class="flex gap-3 pt-4">
              <button
                type="button"
                (click)="prevStep()"
                class="flex-1 bg-white border border-gray-300 text-gray-700 py-3 px-6 rounded-lg font-semibold hover:bg-gray-50 transition-colors"
              >
                Voltar
              </button>
              <button
                type="button"
                (click)="nextStep()"
                class="flex-1 bg-[#4A90E2] text-white py-3 px-6 rounded-lg font-semibold hover:bg-[#3a7fc2] transition-colors"
              >
                Continuar
              </button>
            </div>
          </div>
        </div>

        <!-- Step 3: Conta (ou Passo 3 em modo edição = confirmação) -->
        <!-- Step 3: Conta (apenas em modo registro) -->
        <div *ngIf="currentStep === 3 && !isEditMode">
          <h2 class="text-lg sm:text-xl font-bold text-gray-900 mb-1">
            Informações da Conta
          </h2>
          <p class="text-gray-600 mb-4 sm:mb-6 text-sm">
            Defina suas credenciais de acesso
          </p>

          <div class="space-y-4">
            <!-- Senha (apenas em modo registro) -->
            <div *ngIf="!isEditMode">
              <label class="block text-sm font-medium text-gray-900 mb-1"
                >Senha *</label
              >
              <div class="relative">
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  [(ngModel)]="formData.senha"
                  name="senha"
                  #senha="ngModel"
                  required
                  minlength="6"
                  [class.border-red-500]="submitted && senha.invalid"
                  class="w-full px-4 py-3 pr-12 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4A90E2] focus:border-transparent"
                  placeholder="Mínimo 6 caracteres"
                />
                <button
                  type="button"
                  (click)="togglePassword()"
                  class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                >
                  <svg
                    *ngIf="!showPassword"
                    class="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                    />
                  </svg>
                  <svg
                    *ngIf="showPassword"
                    class="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <!-- Confirmar Senha (apenas em modo registro) -->
            <div *ngIf="!isEditMode">
              <label class="block text-sm font-medium text-gray-900 mb-1"
                >Confirmar Senha *</label
              >
              <div class="relative">
                <input
                  [type]="showPasswordConfirm ? 'text' : 'password'"
                  [(ngModel)]="formData.senhaConfirmacao"
                  name="senhaConfirmacao"
                  #senhaConfirmacao="ngModel"
                  required
                  [class.border-red-500]="submitted && senhaConfirmacao.invalid"
                  class="w-full px-4 py-3 pr-12 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4A90E2] focus:border-transparent"
                  placeholder="Confirme sua senha"
                />
                <button
                  type="button"
                  (click)="togglePasswordConfirm()"
                  class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                >
                  <svg
                    *ngIf="!showPasswordConfirm"
                    class="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                    />
                  </svg>
                  <svg
                    *ngIf="showPasswordConfirm"
                    class="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                    />
                  </svg>
                </button>
              </div>
              <p
                *ngIf="
                  formData.senha &&
                  formData.senhaConfirmacao &&
                  formData.senha !== formData.senhaConfirmacao
                "
                class="mt-1 text-sm text-red-600"
              >
                As senhas não coincidem
              </p>
            </div>

            <!-- E-mail -->
            <app-input
              label="E-mail"
              type="email"
              [(ngModel)]="formData.email"
              name="email"
              #email="ngModel"
              [required]="!isEditMode"
              [readonly]="isEditMode"
              placeholder="seu@email.com"
              [error]="getEmailError() || (submitted && email.invalid ? 'E-mail é obrigatório' : '')"
            ></app-input>

            <!-- Confirmar E-mail (apenas em modo registro) -->
            <app-input
              *ngIf="!isEditMode"
              label="Confirmar E-mail"
              type="email"
              [(ngModel)]="formData.emailConfirmacao"
              name="emailConfirmacao"
              #emailConfirmacao="ngModel"
              required
              placeholder="Confirme seu e-mail"
              [error]="
                getEmailError() ||
                (submitted && emailConfirmacao.invalid
                  ? 'Confirmação de e-mail é obrigatória'
                  : formData.email &&
                    formData.emailConfirmacao &&
                    formData.email !== formData.emailConfirmacao
                  ? 'Os e-mails não coincidem'
                  : '')
              "
            ></app-input>

            <!-- E-mail Alternativo -->
            <app-input
              label="E-mail Alternativo"
              type="email"
              [(ngModel)]="formData.emailAlternativo"
              name="emailAlternativo"
              placeholder="email.alternativo@exemplo.com"
            ></app-input>

            <!-- Alerta de erro Passo 3 -->
            <div
              *ngIf="submitted && !validateCurrentStep()"
              class="bg-red-50 border border-red-200 rounded-lg p-4"
            >
              <div class="flex gap-3">
                <svg
                  class="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                    clip-rule="evenodd"
                  />
                </svg>
                <div>
                  <h3 class="text-sm font-medium text-red-800 mb-1">
                    Erro nos campos
                  </h3>
                  <p class="text-sm text-red-700">
                    Verifique se todos os campos obrigatórios estão preenchidos
                    e se as senhas e e-mails coincidem.
                  </p>
                </div>
              </div>
            </div>

            <!-- Botões -->
            <div class="flex gap-3 pt-4">
              <button
                type="button"
                (click)="prevStep()"
                class="flex-1 bg-white border border-gray-300 text-gray-700 py-3 px-6 rounded-lg font-semibold hover:bg-gray-50 transition-colors"
              >
                Voltar
              </button>
              <button
                type="button"
                (click)="nextStep()"
                class="flex-1 bg-[#4A90E2] text-white py-3 px-6 rounded-lg font-semibold hover:bg-[#3a7fc2] transition-colors"
              >
                Continuar
              </button>
            </div>
          </div>
        </div>

        <!-- Step 4: Confirmação (ou Step 3 em modo edição) -->
        <div *ngIf="(currentStep === 4 && !isEditMode) || (currentStep === 3 && isEditMode)">
          <h2 class="text-lg sm:text-xl font-bold text-gray-900 mb-1">
            Confirmação
          </h2>
          <p class="text-gray-800 mb-4 sm:mb-6 text-sm">
            Revise suas informações antes de finalizar
          </p>

          <div class="space-y-4">
            <!-- Resumo -->
            <div class="bg-slate-50 rounded-lg p-5 mb-4">
              <h3 class="font-bold text-gray-900 mb-4">
                Resumo das Informações
              </h3>
              <div class="space-y-2 text-sm">
                <div class="flex justify-between">
                  <span class="text-gray-800">Nome Completo:</span>
                  <span class="font-semibold">{{ formData.nomeCompleto }}</span>
                </div>
                <div class="flex justify-between">
                  <span class="text-gray-800">CPF:</span>
                  <span class="font-semibold">{{ formData.cpf }}</span>
                </div>
                <div class="flex justify-between">
                  <span class="text-gray-800">E-mail:</span>
                  <span class="font-semibold">{{ formData.email }}</span>
                </div>
                <div class="flex justify-between">
                  <span class="text-gray-800">Telefone:</span>
                  <span class="font-semibold">{{ formData.telefone }}</span>
                </div>
                <div class="flex justify-between">
                  <span class="text-gray-800">Cidade/Estado:</span>
                  <span class="font-semibold"
                    >{{ getCidadeNome() }}/{{ getEstadoUF() }}</span
                  >
                </div>
              </div>
            </div>

            <!-- Checkboxes -->
            <div class="space-y-3">
              <label class="flex items-start gap-3 cursor-pointer">
                <input
                  type="checkbox"
                  [(ngModel)]="formData.receberInformacoes"
                  name="receberInformacoes"
                  class="w-4 h-4 mt-1 accent-blue-500"
                />
                <span class="text-sm text-gray-800">
                  Desejo receber informações da organização Rioetramento Email
                  para o meu email cadastrado informado acima
                </span>
              </label>

              <label class="flex items-start gap-3 cursor-pointer">
                <input
                  type="checkbox"
                  [(ngModel)]="formData.aceitaTermos"
                  name="aceitaTermos"
                  required
                  class="w-4 h-4 mt-1 accent-blue-500"
                />
                <span class="text-sm text-gray-800">
                  Declaro que estou ciente que é de minha responsabilidade
                  manter os canais de comunicação cadastrados, atualizados e
                  acompanhar as publicações e comunicações relativas ao
                  concurso, bem como ler atentamente o edital. *
                </span>
              </label>
            </div>

            <!-- Alerta de erro Passo 4 -->
            <div
              *ngIf="submitted && !formData.aceitaTermos"
              class="bg-red-50 border border-red-200 rounded-lg p-4"
            >
              <div class="flex gap-3">
                <svg
                  class="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                    clip-rule="evenodd"
                  />
                </svg>
                <div>
                  <h3 class="text-sm font-medium text-red-800 mb-1">
                    Aceite dos termos obrigatório
                  </h3>
                  <p class="text-sm text-red-700">
                    Você deve aceitar os termos e condições para finalizar o
                    cadastro.
                  </p>
                </div>
              </div>
            </div>

            <!-- Botões -->
            <div class="flex gap-3 pt-4">
              <button
                type="button"
                (click)="prevStep()"
                class="flex-1 bg-white border border-gray-300 text-gray-700 py-3 px-6 rounded-lg font-semibold hover:bg-gray-50 transition-colors"
              >
                Voltar
              </button>
              <button
                type="submit"
                [disabled]="!formData.aceitaTermos || isLoading"
                class="flex-1 bg-green-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
              >
                <svg
                  *ngIf="isLoading"
                  class="animate-spin h-5 w-5 text-white"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                  ></circle>
                  <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                <span>{{
                  isLoading ? "Salvando..." : "Salvar Informações Pessoais"
                }}</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- Link para Login -->
    <div class="mt-6 text-center sm:hidden">
      <a
        routerLink="/login"
        class="text-gray-600 hover:text-gray-900 text-sm font-medium"
      >
        Já tem conta? Entrar
      </a>
    </div>
  </div>
</div>

<app-toast></app-toast>